import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import "./NavigationBar.css";
import { AuthContext } from "../context/AuthContext";
export default function NavigationBar() {


const { isLoggedIn } = useContext(AuthContext);

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/character-counter", label: "Counter" },
    { to: "/contact", label: "Contact" },
    { to: "/about", label: "About" },
  ];

  // Add conditional links
  if (!isLoggedIn) {
    navLinks.push(
      { to: "/signin", label: "Sign In" },
      { to: "/signup", label: "Sign Up" }
    );
  } else {
    navLinks.push({ to: "/profile", label: "Profile" });
  }

  return (
    <nav className="navbar navbar-expand-lg">
      <div className="container-fluid">
        <NavLink className="navbar-brand" to="/">
          <span className="brand-icon">🧮</span>
          <span className="brand-text">CharCount</span>
        </NavLink>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            {navLinks.map((nav) => (
              <li className="nav-item" key={nav.to}>
                <NavLink
                  to={nav.to}
                  className={({ isActive }) =>
                    `nav-link${isActive ? " active" : ""}`
                  }
                >
                  {nav.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}
